'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z' });

var KeyboardBackspace = function KeyboardBackspace(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

KeyboardBackspace = (0, _pure2.default)(KeyboardBackspace);
KeyboardBackspace.muiName = 'SvgIcon';

exports.default = KeyboardBackspace;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/KeyboardBackspace.js
// module id = 2521
// module chunks = 0